import type {BaseQueryFn, FetchArgs, FetchBaseQueryError} from "@reduxjs/toolkit/query";
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import qs from "query-string";

import {getCookie} from "@pg-mono/request";

import {isDevelopment, isServer} from "../read_rp_environment_variables";
import {appendCacheMissHeader} from "../utils/append_cache_miss_header";
import {fetchWithServices} from "./fetch_with_services";

const msStoreServicesBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    const endpointUrl = typeof args === "string" ? args : args.url;
    const absoluteUrl = isDevelopment ? new URL(endpointUrl).pathname : endpointUrl;

    const adjustedArgs = typeof args === "string" ? `${absoluteUrl}` : {...args, url: `${absoluteUrl}`};

    const msStoreBaseQuery = fetchBaseQuery({
        paramsSerializer: qs.stringify,
        prepareHeaders: (headers, api) => {
            const customCsrfToken = headers.get("X-CSRFToken");
            const csrf = !isServer ? getCookie("csrftoken") : null;

            if (api.type === "mutation") {
                headers.set("Content-Type", "application/json");
            }

            if (api.type === "mutation" && !customCsrfToken && csrf) {
                headers.set("X-CSRFToken", csrf);
            }

            appendCacheMissHeader(headers, api);

            return headers;
        },
        fetchFn: fetchWithServices(api),
        timeout: 30000
    });

    return msStoreBaseQuery(adjustedArgs, api, extraOptions);
};

export const msStoreApi = createApi({
    reducerPath: "msStoreApi",
    baseQuery: msStoreServicesBaseQuery,
    endpoints: () => ({}),
    tagTypes: []
});
import type {BaseQueryFn, FetchArgs, FetchBaseQueryError} from "@reduxjs/toolkit/query";
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import qs from "query-string";

import {getCookie} from "@pg-mono/request";

import {isDevelopment, isServer} from "../read_rp_environment_variables";
import {appendCacheMissHeader} from "../utils/append_cache_miss_header";
import {fetchWithServices} from "./fetch_with_services";

const msStoreServicesBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    const endpointUrl = typeof args === "string" ? args : args.url;
    const absoluteUrl = isDevelopment ? new URL(endpointUrl).pathname : endpointUrl;

    const adjustedArgs = typeof args === "string" ? `${absoluteUrl}` : {...args, url: `${absoluteUrl}`};

    const msStoreBaseQuery = fetchBaseQuery({
        paramsSerializer: qs.stringify,
        prepareHeaders: (headers, api) => {
            const customCsrfToken = headers.get("X-CSRFToken");
            const csrf = !isServer ? getCookie("csrftoken") : null;

            if (api.type === "mutation") {
                headers.set("Content-Type", "application/json");
            }

            if (api.type === "mutation" && !customCsrfToken && csrf) {
                headers.set("X-CSRFToken", csrf);
            }

            appendCacheMissHeader(headers, api);

            return headers;
        },
        fetchFn: fetchWithServices(api),
        timeout: 30000
    });

    return msStoreBaseQuery(adjustedArgs, api, extraOptions);
};

export const msStoreApi = createApi({
    reducerPath: "msStoreApi",
    baseQuery: msStoreServicesBaseQuery,
    endpoints: () => ({}),
    tagTypes: []
});
